// src/auth/AuthProvider.tsx
import { Auth0Provider } from "@auth0/auth0-react";

const AuthProvider = ({ children }: { children: React.ReactNode }) => (
  <Auth0Provider
    domain="dev-vclj8q6l6scof8yg.us.auth0.com"
    clientId="TgQ0BifTKfC2rP3RqeW4nxLCw2pR0ZYE"
    authorizationParams={{
      redirect_uri: window.location.origin,
    }}
  >
    {children}
  </Auth0Provider>
);

export default AuthProvider;
